import { useState } from "react";
import { toast } from "sonner";
import { RefreshCw, Stethoscope, ChevronDown } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { STATUS } from "@/lib/constants";
import { Button } from "@/components/ui/button";

export const QueueDiagnose = ({ onChanged }) => {
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const diagnose = async () => {
    setBusy(true);
    try { const r = await api.get("/queue/diagnose"); setData(r.data); setOpen(true); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const rematch = async () => {
    setBusy(true);
    try { const r = await api.post("/queue/rematch"); toast.success(`Pencocokan ulang selesai: ${r.data.new_matches} match baru`); onChanged?.(); await diagnose(); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className="mb-4" data-testid="queue-diagnose">
      <div className="flex flex-wrap gap-2">
        <Button variant="outline" size="sm" onClick={diagnose} disabled={busy} data-testid="queue-diagnose-btn"><Stethoscope className="h-4 w-4 mr-1" />Kenapa antrian sedikit?</Button>
        <Button variant="outline" size="sm" onClick={rematch} disabled={busy} data-testid="queue-rematch-btn"><RefreshCw className={`h-4 w-4 mr-1 ${busy ? "animate-spin" : ""}`} />Cocokkan ulang semua</Button>
      </div>
      {open && data && (
        <div className="mt-3 rounded-xl border bg-card p-4 text-sm space-y-3" data-testid="queue-diagnose-panel">
          <div className="flex flex-wrap gap-x-6 gap-y-1 font-mono text-xs">
            <span>Job Dibuka: <b>{data.open_jobs}</b></span>
            <span>Job aktif (belum lewat due): <b>{data.active_jobs}</b></span>
            <span>Siswa bisa dicocokkan: <b>{data.matchable_pool}</b></span>
            <span>Match pending: <b>{data.pending_matches}</b></span>
          </div>
          {data.inactive_open_jobs?.length > 0 && <p className="text-xs text-destructive">Job Dibuka tapi lewat due date (tidak dicocokkan): {data.inactive_open_jobs.join(", ")}</p>}
          <div className="flex flex-wrap gap-1.5">{Object.entries(data.candidates_by_status).sort((a, b) => b[1] - a[1]).map(([s, n]) => <span key={s} className="rounded-full border px-2 py-0.5 text-xs">{STATUS?.[s]?.label || s}: <b>{n}</b></span>)}</div>
          <p className="text-xs text-muted-foreground">Hanya siswa berstatus Terdaftar, Pra Pendidikan, Matched, atau Direview yang dicocokkan. Siswa yang sudah dikenalkan/wawancara/placement tidak ikut.</p>
          <div className="space-y-1">{data.per_job.map((j) => (
            <details key={j.code} className="rounded-lg border px-3 py-2" data-testid={`diag-job-${j.code}`}>
              <summary className="cursor-pointer flex items-center gap-2"><ChevronDown className="h-3 w-3" /><span className="font-mono text-xs">{j.code}</span><span className="truncate flex-1">{j.title}</span><span className={`text-xs font-semibold ${j.eligible ? "text-emerald-700" : "text-destructive"}`}>{j.eligible} lolos</span></summary>
              <ul className="mt-2 pl-5 text-xs text-muted-foreground list-disc">{j.reasons.map(([r, n]) => <li key={r}>{r}: <b>{n}</b> siswa</li>)}{j.reasons.length === 0 && <li>Semua siswa lolos</li>}</ul>
            </details>
          ))}</div>
        </div>
      )}
    </div>
  );
};
